<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { required, email, numeric, helpers } from 'vuelidate/lib/validators'
import { driversLicense, USDLRegex, isDate } from 'src/utils/validators'
import { notify } from 'src/plugins/notify'
import AwesomeMask from 'awesome-mask'
import SlDateTime from 'components/Shared/DatePicker' 
let moment = require('moment')

export default {
  name: 'ClassVerified',
  validations () {
    let vm = this
    return {
      student: {
        dl: { 
          required,
          driversLicenseValidation: vm.testDL
        },
        dl_state: { required },
        firstName: { required },
        lastName: { required },
        address1: { required },
        city: { required },
        zip: { required },
        gender: { required },
        dob: { isDate, required },
        phone: { required },
        email: { required }
      }
    }
  },
  directives: {
    'mask': AwesomeMask
  },
  components: {
    SlDateTime
  },
  mounted (){
    const vm = this
      let firstRegisterableSessionIndex = vm.getOpenSessions.findIndex(x => x.canRegister)
      if(firstRegisterableSessionIndex > -1) vm.setSelectedSession({id: vm.getOpenSessions[firstRegisterableSessionIndex].SESSION_ID, index:firstRegisterableSessionIndex, value: true })
    
    this.$v.$reset()
  },
  data(){
    return {
      driversLicenseUploaded: true
    }
  },
  computed: {
    ...mapState('attend',{
      currentClass : s => s.class,
      sessions: s => s.sessions,
      studentEntry: s => s.studentEntry,
      signupComplete: s => s.signupComplete,
      selectedSession: s => s.selectedSession,
      student: s => s.student,
      classCode: s => s.classCode
    }),
    ...mapState({
      genderOptions: s => s.shared.genders
    }),
    ...mapGetters('attend',[
      'getOpenSessions'
    ]),
    ...mapGetters([
      'stateOptions'
    ]),
    driversLicenseError(){
      if(!this.student.dl) return "Drivers License Required"      

      let state = _.find(this.stateOptions,{ value: this.student.dl_state })
      const errorMessage = (state) ? USDLRegex[state.label].description.join(', ') : ''
      return errorMessage
    },
    mappedSessions(){
      return this.getOpenSessions.map(x => {
        let canRegister = true
        x.pastRegistrationDate = false

        // Dates > Start and < End
        if(!moment().isBefore(moment(x.SESSION_START_DATE,"YYYY-MM-DD HH:mm").utc())){
          canRegister = false
          x.pastRegistrationDate = true
        }
        if(x.past_max_students) canRegister = false
        x.canRegister = canRegister
        return x
      })
    },
    hasRegisterableSessions(){
      return this.mappedSessions.some(x => x.canRegister)
    }
  },
  methods: {
    ...mapActions('attend', [
      'completeRegistration'
    ]),
    ...mapMutations('attend', [
      'clearCurrentClass',
      'studentEntryState',
      'setSelectedSession',
      'updateStudentRecord',
      'autocompleteAddressStudentPublicStudentUpdate'
    ]),
    getInvalidSessionReason(i){
      let session = this.mappedSessions[i]
      if(session.pastRegistrationDate) return 'Registration date has passed.'
      if(session.past_max_students) return 'Max number of students reached.'
    },
    /**
     * Should Sync Session?
     * Returns if this session is not the first but the sync students is set to one
     */
    shouldForceSession(index){
      return this.sessions[index].SYNC_STUDENTS === 1
    },
    testDL(){      
      let state = _.find(this.stateOptions,{ value: this.student.dl_state })
      const stateRegex = new RegExp(USDLRegex[state.label].rule)
      // Test State regexp, strip all dashes, trim whitespace and uppercase letters.
      const valid = stateRegex.test(this.student.dl.replace(new RegExp('-','g'),'').trim().toUpperCase())
      return valid
    },
    advanceToStudentEntry(){
      let vm = this
      if(vm.selectedSession.length > 0){
        vm.studentEntryState(true)
      }
      else{
        notify.create({message:'Please select a session!', type:'negative'})
      }
    },
    getStateAbbr(id){
      let vm = this
      let stateObj = _.find(vm.stateOptions,{value:id})
      return stateObj ? stateObj.label.trim() : 'AL'
    },
    completeRegistrationMethod(){
      let vm = this
      vm.$v.$touch()
      if(!vm.$v.$invalid){
        vm.completeRegistration()
      }
    },
    validateReq(field){
      return field.$dirty && !field.required
    },
    selectedSessionObj(){
      let vm = this
      return _.find(vm.getOpenSessions,{SESSION_ID:vm.selectedSession[0]})
    },
    formatDate(date){
      return moment(date).utc().format('MMMM Do, YYYY [at] h:mma')
    },
    goToLoginAndReset(){
      let vm = this
      vm.resetState()
      this.$router.push('/login')
    },
    placeChange(place) {
      this.autocompleteAddressStudentPublicStudentUpdate({
        place,
        stateOptions: this.stateOptions
      });
    }
  }
}

</script>

<template>
  <q-card-main id="class-verified" class="content-center col-12">    
    <div v-if="!studentEntry && !signupComplete">
      <h4 class="underline" style="margin-top:30px">Class {{currentClass.CLASS_ID}} Sign Up</h4>
      <h6 v-if="getOpenSessions.length > 0">Please Select A Session:</h6>
      <q-list class="q-mt-md">
        <q-item v-for="(session, i) in getOpenSessions" :key="i" link tag="label">
          <q-item-side>
            <q-checkbox :disable="!mappedSessions[i].canRegister" :value="selectedSession.includes(session.SESSION_ID)" :val="session.SESSION_ID" @change="v => setSelectedSession({id:session.SESSION_ID,value: v, index:i})" />
          </q-item-side>
          <q-item-main>
            {{`Session ${i+1}`}}
            <p class="text-red" style="font-weight:500;font-size:13px;" v-if="getInvalidSessionReason(i)">
                <q-icon name="cancel" /> {{getInvalidSessionReason(i)}}             
            </p>
            <!-- <p style="font-size:12px" class="text-negative">Sorry, This class Registration Date has passed.</p> -->
          </q-item-main>
          <q-item-side>
            {{formatDate(session.SESSION_START_DATE)}}
          </q-item-side>
        </q-item>
        <q-item v-if="getOpenSessions.length == 0">
          <span>
            <h5 class="text-red">No Open Sessions Available.</h5><br> Please Ask your instructing agency to open registration for at least one session.
          </span>
        </q-item>
      </q-list>
      <div style="margin-top:20px" class="text-right">
        <q-btn label="Back" outline color="secondary" @click="clearCurrentClass()" />&nbsp;
        <q-btn v-if="hasRegisterableSessions" @click="advanceToStudentEntry()" color="primary" style="margin-right:6px" label="Continue" />
      </div>
    </div>
    <div v-if="studentEntry && !signupComplete">
      <span class="text-meta text-grey-8 font-weight-medium" style="font-size:12px">{{selectedSession.length}} SESSION{{selectedSession.length > 1 ? '' : 'S'}}</span>
      <h4 class="underline" style="margin-top:0px">Class {{currentClass.CLASS_ID}}</h4>
      <h5 style="margin: 0 13px 45px;">Enter Your Details</h5>
      <div v-if="!driversLicenseUploaded">
        <q-uploader float-label="Drivers License Front*" extensions=".gif,.jpg,.jpeg,.png" auto-expand hide-upload-button hide-upload-progress class="q-mb-md" />
        <q-uploader float-label="Drivers License Back*" auto-expand hide-upload-button hide-upload-progress />
      </div>
      <div v-if="driversLicenseUploaded" class="">
        <div class="sl-row">
          <div class="sl-col-3">
              <q-select
                float-label="DL State"
                :value="student.dl_state"
                :options="stateOptions"
                @change="val => updateStudentRecord({ field: 'dl_state', value: val })"
                filter
                autofocus-filter
              />
          </div>
          <div class="sl-col-9">
            <q-field
              :error="$v.student.dl.$error"
              :error-label="driversLicenseError"
              >
            <q-input
              float-label="Drivers License #"
              :value="student.dl"
              :after="[{icon: 'flag', error:true }]"
              @blur="$v.student.dl.$touch"
              :error="validateReq($v.student.dl)"
              @keyup.stop="updateStudentRecord({ field: 'dl', value: $event.target.value })"/>
            </q-field>
          </div>
        </div>
        <div class="sl-row">
          <div class="sl-col-4">
            <q-input
              float-label="First Name"
              :value="student.firstName"
              @keyup.stop="updateStudentRecord({ field: 'firstName', value: $event.target.value })"
              @blur="$v.student.firstName.$touch"
              :error="validateReq($v.student.firstName)" :after="[{icon: 'flag', error:true }]"
              />
          </div>
          <div class="sl-col-4">
            <q-input
              float-label="Middle Name"
              :value="student.middleName"
              @keyup.stop="updateStudentRecord({ field: 'middleName', value: $event.target.value })" />
          </div>
          <div class="sl-col-4">
            <q-input
              float-label="Last Name"
              :value="student.lastName"
              @blur="$v.student.lastName.$touch"
              @keyup.stop="updateStudentRecord({ field: 'lastName', value: $event.target.value })"
              :error="validateReq($v.student.lastName)" :after="[{icon: 'flag', error:true }]"
            />
          </div>
        </div>
        <div class="sl-row">
          <div class="sl-col-12">
            <q-input
              float-label="Address"
              :value="student.address1"
              @blur="$v.student.address1.$touch"
              @keyup.stop="updateStudentRecord({ field: 'address1', value: $event.target.value })"
              :error="validateReq($v.student.address1)" :after="[{icon: 'flag', error:true }]"
              v-places-autocomplete="{ onSelect: placeChange, classCode }"
              ref="googleAutocomplete"
              autocomplete="new-password"
            />
          </div>
        </div>
        <div class="sl-row">
          <div class="sl-col-5">
            <q-input float-label="City"
              :value="student.city"
              @keyup.stop="updateStudentRecord({ field: 'city', value: $event.target.value })"
              @blur="$v.student.city.$touch"
              :error="validateReq($v.student.city)" :after="[{icon: 'flag', error:true }]"
              autocomplete="new-password"
            />
          </div>
          <div class="sl-col-3">
            <q-select
              float-label="State"
              :value="student.state"
              :options="stateOptions"
              @change="val => updateStudentRecord({ field: 'state', value: val })"
              autocomplete="new-password"
              filter
              autofocus-filter
            />
          </div>
          <div class="sl-col-4">
            <q-input
              float-label="Zip"
              :value="student.zip"
              @keyup.stop="updateStudentRecord({ field: 'zip', value: $event.target.value })"
              autocomplete="new-password"
              @blur="$v.student.zip.$touch"
              :error="validateReq($v.student.zip)" :after="[{icon: 'flag', error:true }]"
              />
          </div>
        </div>
        <div class="sl-row">
          <div class="sl-col-3">
            <q-select
              float-label="Gender"
              :value="student.gender"
              @change="val => updateStudentRecord({ field: 'gender', value: val })"
              :options="genderOptions"
              filter
              autofocus-filter
              />
          </div>
          <div class="sl-col-4">
              <q-field
                :error="$v.student.dob.$error"
                error-label="Invalid Date"
                >
                <sl-date-time
                  type="date"
                  float-label="Date of Birth"
                  :value="student.dob"
                  @blur="$v.student.dob.$touch"
                  @keyup.stop="updateStudentRecord({ field: 'dob', value: $event.target.value })"
                />
              </q-field>
          </div>
          <div class="sl-col-5">
            <q-input float-label="Phone"
              :value="student.phone"
              @blur="$v.student.phone.$touch"
              :error="validateReq($v.student.phone)" :after="[{icon: 'flag', error:true }]"
              @keyup.stop="updateStudentRecord({ field: 'phone', value: $event.target.value })"
              v-mask="'999-999-9999'"
              />
          </div>
        </div>
        <div class="sl-row">
          <div class="sl-col-12">
            <q-input float-label="Email Address"
              :value="student.email"
              @keyup.stop="updateStudentRecord({ field: 'email', value: $event.target.value })"
              @blur="$v.student.email.$touch"
              :error="validateReq($v.student.email)" :after="[{icon: 'flag', error:true }]"
              />
          </div>
        </div>
      </div>
      <div style="margin-top:20px" class="text-right">
        <q-btn label="Back" outline color="secondary" @click="studentEntryState(false)" />&nbsp;
        <q-btn color="primary" @click="completeRegistrationMethod()" style="margin-right:6px" label="Complete" />
      </div>
    </div>
    <div v-if="signupComplete">
      <div class="logo"><span>cascades</span></div>
      <div class="verified">
        <h6>Registration Complete!</h6>
        Your session begins {{formatDate(selectedSessionObj().SESSION_START_DATE)}}
      </div>
      <div style="margin-top:20px" class="text-right">
        <q-btn label="Done" outline color="secondary" @click="clearCurrentClass()" />
      </div>
    </div>
  </q-card-main>
</template>

<style lang="stylus">
  @import '~variables'
  #class-verified
    h4
      &.underline
        position relative
        display table
        padding-bottom 20px
        margin-bottom 60px
        &:after
          content: ""
          position absolute
          height 1px
          width 40%
          background $primary
          bottom 0
          left 0
    .verified
      background #beffd9
      margin 20px 0
      padding 31px
      border-radius 19px
      h6
        color #1fa958
        margin-bottom 12px
        font-weight 600
    .q-uplaoder
      .q-icon + .q-icon
        display none
      .q-uploader-pick-button
        left 0
        position absolute
        right 0
        width 100%
        text-align right
        justify-content flex-end
</style>
